import * as React from 'react';
import { Datagrid, ListProps, ReferenceField, TextField } from 'react-admin';
import './SuccessStoryDatagrid.scss';
import { MediaField } from '../components/MediaField';
import { TranslateField } from '../components/TranslateField';

export const SuccessStoryDatagrid = (props: ListProps): React.ReactElement => {
	return (
		<Datagrid rowClick="edit" className="success-stories-table" optimized
		          hasBulkActions={true}
		          rowStyle={(row: any) => ({ borderRightColor: row._readAt ? '#49d18c' : '#bbbbbb' })}>
			<TextField source="id" label="#"/>
			<MediaField source="featuredImageUrl" label="IMAGE_OR_VIDEO"/>
			<TextField source="title" label="TITLE"/>
			<TextField source="description" label="DESCRIPTION"/>
			<ReferenceField source="categoryId" reference="success-story-categories" label="CATEGORY">
				<TextField source="name"/>
			</ReferenceField>

			<ReferenceField source="createdById" reference="clients" label="CREATED_BY">
				<TextField source="fullName"/>
			</ReferenceField>
			{/*<ImageField source="gallery" label="GALLERY"/>*/}
			<TranslateField source="language" label="LANGUAGE"/>
		</Datagrid>
	);
};
